import {createAction} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {ValidationErrors} from '../../constants'
import {getFullUserInfo, getUserRatesValidationData} from '../../userData/selectors'
import {getUserRatesErrors, getValidRates, isRateEmpty} from './validationUtils'
import {getErrors, getLastEditedUserRate, getUserRates} from './selectors'
import * as UserDataActions from '../../userData/actions'
import messageResource from '../../../../messageResource'
import {performUpdateCall} from '../../editPanel/actions'
import {getUserManagementData} from '../../../../administration/userManagement/common/selectors'

export const setErrors = createAction(ActionTypes.ERRORS_SET)
export const clearErrors = createAction(ActionTypes.ERRORS_CLEAR)
export const setLastEditedUserRate = createAction(ActionTypes.LAST_EDITED_USER_RATE_SET)
export const setUpdating = createAction(ActionTypes.UPDATING_SET)

export const rollbackLastEditedUserRateChanges = () => (dispatch, getState) => {
    const state = getState()
    const {index, rate} = getLastEditedUserRate(state)
    const rates = [...getUserRates(state)]
    rates.splice(index, 1, rate)

    const {overtimeEnabled, leaveTypesEnabled} = getUserRatesValidationData(state)
    const {errors} = getUserRatesErrors(rates, overtimeEnabled, leaveTypesEnabled, false, index, rate)
    dispatch(setErrors(errors))
    dispatch(UserDataActions.setFullUserInfo({rates}))
}

export const updateUserRates = ({index, rate}) => (dispatch, getState) => {
    const state = getState()
    const prevRates = getUserRates(state)
    const rates = [...prevRates]
    rates.splice(index, 1, rate)

    const {overtimeEnabled, leaveTypesEnabled} = getUserRatesValidationData(state)

    const {errors} = getUserRatesErrors(rates, overtimeEnabled, leaveTypesEnabled, true, index, prevRates[index])

    dispatch(setLastEditedUserRate({index, rate: prevRates[index]}))

    dispatch(UserDataActions.setFullUserInfo({rates}))

    dispatch(setErrors(errors))

    if (!errors[index] && !isRateEmpty(rate, overtimeEnabled, leaveTypesEnabled)) {
        dispatch(updateValidUserRates(rates))
    }
}

export const updateValidUserRates = (rates) => (dispatch, getState) => {
    const {overtimeEnabled, leaveTypesEnabled} = getUserRatesValidationData(getState())
    dispatch(UserDataActions.removeUserPanelErrors([ValidationErrors.DUPLICATED_EFFECTIVE_DATE]))

    const validRates = getValidRates({rates, overtimeEnabled, leaveTypesEnabled})

    if (validRates.length === 0) {
        dispatch(UserDataActions.setFullUserInfo({rates}))
    } else {
        dispatch(setUpdating(true))
        dispatch(performUpdateCall("UserManagementService.updateUserRates", [validRates],
            () => {
                //rates updated in performUpdateCall, no need update here
                dispatch(setUpdating(false))
            },
            error => {
                dispatch(setUpdating(false))
                if (error._providerStatus === ValidationErrors.DUPLICATED_EFFECTIVE_DATE) {
                    alert(messageResource.getMessage('userlist.userdata.user_rates.duplicate_effective'))
                    dispatch(UserDataActions.setFullUserInfo({rates}))
                }
            })
        )
    }
}

export const addNewUserRate = () => (dispatch, getState) => {
    const state = getState()
    const userRates = getUserRates(state)
    const currentDateStr = getUserManagementData(state).todayInViewerTimeZone.parseJSONDate().toJSON()

    const newRate = {
        rateId: -1,
        effectiveDate: userRates.find(rate => rate.effectiveDate === currentDateStr) ? null : currentDateStr,
        regularRate: null,
        overtimeRate: null,
        leaveRates: []
    }

    dispatch(UserDataActions.setFullUserInfo({
        rates: [...userRates, newRate]
    }))
}

export const deleteUserRate = ({rateId, removePermanently = false, index}) => (dispatch, getState) => {
    const state = getState()
    const rates = [...getUserRates(state)]

    if (removePermanently) {
        rates.splice(index, 1)
        dispatch(UserDataActions.setFullUserInfo({rates}))
        const errors = [...getErrors(state)]
        errors.splice(index, 1)
        dispatch(setErrors(errors))
    } else {
        dispatch(setUpdating(true))
        dispatch(performUpdateCall("UserManagementService.deleteUserRate", [rateId],
            () => {
                dispatch(setUpdating(false))
                const rates = getFullUserInfo(state).rates.filter(rate => rate.rateId !== rateId)
                dispatch(UserDataActions.setFullUserInfo({rates}))
            })
        )
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/userRates/actions.js